<template>
    <div id="wz_header">
        <div class="inner_l">
            <!-- <a href="#" class="prev_wz" :class="getSiblingArticle(-1, 'prev') > 0 && !isPreview ? '' : 'hidden'" @click="changeWebzine(prevWebzine.webzine_id)">{{this.prevWebzine.webzine_title}}</a> -->
            <el-button type="primary" @click="changeWebzine()"
                >목록으로</el-button
            >
            <el-tooltip
                class="item"
                effect="dark"
                content="목록으로"
                placement="bottom"
            >
                <a href="#" @click="changeWebzine()" class="logo">
                    <img :src="logoImageUrl" alt="웹진 치읓치읓" />
                </a>
            </el-tooltip>
            <div class="hidden"></div>
            <!-- <a href="#" class="next_wz" :class="getSiblingArticle(1, 'next') > 0 && !isPreview ? '' : 'hidden'" @click="changeWebzine(nextWebzine.webzine_id)">{{this.nextWebzine.webzine_title}}</a> -->
        </div>
        <div class="inner_r">
            <div
                class="select_wrap"
                v-if="
                    mode !== 'preview' && webZineList && webZineList.length > 0
                "
            >
                <select
                    v-model="webzineId"
                    placeholder="웹진 선택"
                    title="웹진 선택"
                    id="wz_volume"
                    @change="changeWebzine()"
                >
                    <option
                        v-for="webzine in webZineList"
                        :key="webzine.webzine_id"
                        :value="webzine.webzine_id"
                        :label="webzine.webzine_title"
                    ></option>
                </select>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import { findIndex, filter } from "lodash";

export default {
    name: "ArticleHeader",
    computed: {
        ...mapGetters("webzineView", [
            "articleList",
            "categoryList",
            "webzine",
            "selectedArticleId",
            "selectedArticle",
            "selectedWebZineId",
            "webZineList",
            "isPreview",
            "mode",
        ]),
    },
    watch: {
        selectedWebZineId() {
            if (this.selectedWebZineId) {
                this.webzineId = this.selectedWebZineId;
            }
        },
    },
    mounted() {
        this.webzineId = this.selectedWebZineId;
    },
    data() {
        return {
            logoImageUrl: this.$baseURL + "/images/webzine/logo-header.svg",
            webzineId: undefined,
            prevWebzine: {},
            nextWebzine: {},
        };
    },
    methods: {
        ...mapActions("webzineView", ["getArticle"]),
        ...mapMutations("webzineView", [
            "setSelectedArticleId",
            "setSelectedWebZineId",
        ]),
        changeWebzine(webzineId) {
            if (webzineId) {
                this.webzineId = webzineId;
            }

            if (this.webzineId !== "all") {
                this.setSelectedWebZineId(this.webzineId);
            } else {
                return false;
            }

            const url = `/${this.mode}/${this.webzineId}`;
            this.$router.push(url);
        },

        getSiblingArticle(no, type) {
            const webzineId = this.selectedWebZineId;
            const webzineList = filter(this.webZineList, (webzine) => {
                return webzine.webzine_id !== "all";
            });
            const idx = findIndex(webzineList, { webzine_id: webzineId });
            if (idx >= 0) {
                if (webzineList[idx + no] && type === "prev") {
                    this.prevWebzine = webzineList[idx + no];
                    return webzineList[idx + no].webzine_id;
                } else if (webzineList[idx + no] && type === "next") {
                    this.nextWebzine = webzineList[idx + no];
                    return webzineList[idx + no].webzine_id;
                } else {
                    return 0;
                }
            } else {
                return 0;
            }
        },

        chkCenter() {
            if (!this.prevWebzine.webzine_id && !this.nextWebzine.webzine_id) {
                return true;
            } else {
                return false;
            }
        },
    },
};
</script>

<style scoped>
.wz-article-toc {
    display: flex;
    max-width: 480px;
}

.wz-article-toc__con {
    width: 100%;
    background-color: #fff;
    display: flex;
    flex-direction: column;
    height: 100%;
    overflow: auto;
}

.wz-article-toc h4 {
    margin: 10px 0;
}

.wz-article-toc h5 {
    margin: 0;
    padding: 10px 5px;
}

.article-title {
    cursor: pointer;
}

.article-title.active,
.article-title:hover {
    color: #c4953b !important;
}

.wz-publish-info {
    display: flex;
    flex-direction: column;
    padding: 25px 30px;
}

.wz-publish-info .info {
    display: flex;
    padding: 4px 0;
}

.wz-publish-info .info > span {
    display: block;
    padding: 0 3px;
}

.wz-publish-info .info > .title {
    font-weight: 300;
    font-size: 13px;
    min-width: 50px;
}

.wz-publish-info .info > .publish {
    word-break: break-all;
    white-space: pre-line;
    font-size: 12px;
}

.main-side-bar {
    display: flex;
    align-items: center;
    justify-content: center;
}

.main-side-bar > a {
    position: fixed;
    top: 0;
    left: 0;
    width: 70px;
    height: 100vh;
    color: #fff;
    writing-mode: tb-rl;
    text-align: center;
    line-height: 70px;
    font-size: 1rem;
    transition: 0.5s;
    text-decoration: none;
    background: linear-gradient(
        0deg,
        rgba(131, 58, 180, 1) 0%,
        rgba(253, 29, 29, 1) 50%,
        rgba(252, 176, 69, 1) 100%
    );
}

.main-side-bar > a:hover {
    text-decoration: none;
    transition: 0.5s;
    width: 70px;
    background: linear-gradient(
        0deg,
        rgba(63, 94, 251, 1) 0%,
        rgba(252, 70, 107, 1) 100%
    );
}

.main-side-bar img {
    width: 25px;
    margin-bottom: 10px;
    margin-right: 11px;
}

.main-side-bar > a > div {
    font-weight: 300;
    width: 500px;
    transform: rotate(90deg);
    text-align: center;
}

.wz_layout #wz_header .inner_l .hidden {
    visibility: hidden !important;
}
</style>
